import styled from "styled-components";

export const InfoContentSeparator = styled.div`
  border-bottom: 1px solid var(--blackShadowColor010);
  width: 100%;
`;
